module.exports = __webpack_public_path__ + "static/media/leftArrow.759db6e1.svg";